import { Link, useHistory } from "react-router-dom";
import { Routes } from "../../../AppRoutes";
import {  Box, Table } from "../../../components";
import {
  getListIdByFieldsContext,
  getProcessPathByListId,
} from "../../procedure/util";
import { useLandingStatistic } from "../../procedure/dashboard/hooks/use-landing-statistic";
import { ColumnsType } from "antd/lib/table";
import { DateHelper } from "../../../helper";

type FinishApproveType = {
  // requests: any[];
  renderCreatedDate: (
    date: string,
    isPin: boolean,
    isAttachment: boolean,
    data: any
  ) => void;
  // isPin: (Request: any) => boolean;
  // isHaveAttachment: (Request: any) => boolean;
};

const FinishApproveTable = (props: FinishApproveType) => {
  const { renderCreatedDate } = props;
  const { approveFinishRequests, isPin, isHaveAttachment } =
    useLandingStatistic();
  const history = useHistory();

  const columns: ColumnsType<any> = [
    {
      title: "Mã YC",
      dataIndex: "id",
      key: "id",
      align: "center" as const,
      width: 120,
      render: (value: any, record: any) => renderCreatedDate(record.id, record.isPin, record.isAttachment, record),
    },
    {
      title: "Nội dung yêu cầu",
      dataIndex: "Title",
      key: "Title",
    },
    {
      title: "Ngày tạo ",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render: (value: any, record: any) => DateHelper.formatDateToString(record.createdDateTime),
      width: 150,
    },
    {
      title: "Người tạo",
      dataIndex: "createdByName",
      key: "createdByName",
    },
  ];

  const dataSource = approveFinishRequests.map((item: any, index: number) => {
    const { eContent, ...restFields } = item.fields;
    return {
      index: index + 1,
      eTag: item.eTag,
      id: item.id,
      ...restFields,
      "fields@odata.context": item["fields@odata.context"],
      createdByName: item.createdBy.user.displayName,
      createdDateTime: item.createdDateTime,
      isPin: isPin(item),
      isAttachment: isHaveAttachment(item),
    };
  });

  return (
    <Box
      title="Yêu cầu đã hoàn tất"
      titleRight={
        <Link
          to={{
            pathname: Routes.details.path,
            search: "requests=approve-finished",
          }}
          className="px-4 pt-2"
        >
          Chi tiết &gt;&gt;&gt;
        </Link>
      }
    >
      <Table
        rowKey="eTag"
        pagination={{ pageSize: 5 }}
        columns={columns}
        dataSource={dataSource}
        onRow={(record) => ({
          onClick: () =>
            history.push(
              getProcessPathByListId(
                getListIdByFieldsContext(record["fields@odata.context"])
              ).replace(":id", record.id)
            ),
          style: { cursor: "pointer" },
        })}
      />
    </Box>
  );
};

export default FinishApproveTable;
